import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText } from '@facet-wealth/design';
import { AccountOpeningV2TrustedContactIntroStepLayout } from './AccountOpeningV2TrustedContactIntroStepLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['introTitle', 'detailTitle'], {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly);

export const AccountOpeningV2TrustedContactIntroStep = () => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();

  return (
    <MetaResourceRenderer
      layout={AccountOpeningV2TrustedContactIntroStepLayout}
      resource={pageContentResource}
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
    />
  );
};
